import { FC } from 'react';
import ROUTES from '../../../constants/routes';
import useNewInteractive from '../../../routes/new-interactive/hooks/use-new-interactive';
import cn from '../../../utils/classnames';
import FontAwesomeIcon from '../../font-awesome-icon/font-awesome-icon';
import Icon from '../../icon/icon';
import withMobileSize from '../../mobile-size/mobile-size';
import './interactive-badge.scss';

const ALLOWED_LINKS: string[] = [
    ROUTES.SEARCH_RESULT.path,
    ROUTES.SALE_LANDING.path,
    ROUTES.SCHOOL_LANDING_PAGES.prefix,
    ROUTES.AUTHOR_MAIN.prefix,
    ROUTES.LANDING.prefix
];

const isAllowedPathname = () => {
    const pathWithoutId = window.location.pathname.split('/').slice(0, 3).join('/');

    return ALLOWED_LINKS.some((route) => pathWithoutId.includes(route));
};

type InteractiveBadgeProps = {
    mobile: boolean;
    width?: number;
    isStandalone?: boolean;
};

const InteractiveBadge: FC<InteractiveBadgeProps> = ({ mobile, isStandalone = false, width }) => {
    const isTooSmall = width !== undefined && width < 150;
    const isNewInteractive = useNewInteractive();
    const isStandaloneBadge = isStandalone && !isTooSmall && (isAllowedPathname() || isNewInteractive);

    if (isStandaloneBadge) {
        const badgeWidth = (width || 0) - (width || 0) * 0.18;
        const onNotEmpty = (v: string | number) => (width === undefined ? undefined : v);

        return (
            <div
                className={cn('interactive-badge-standalone', {
                    sm: mobile,
                    auto: width === undefined
                })}
            >
                <FontAwesomeIcon
                    name='interactive-logo-compact'
                    width={onNotEmpty(badgeWidth - 45)}
                    height={onNotEmpty(badgeWidth / 6) as number}
                    theme='white'
                />
            </div>
        );
    }

    return (
        <div
            className={cn('interactive-badge', {
                md: !mobile,
                sm: mobile
            })}
        >
            <Icon animated={false} name='interactive' />
        </div>
    );
};

export default withMobileSize(InteractiveBadge);
